// extracted by mini-css-extract-plugin
export default {"notice":"rolesPendingInterviews_notice__5SjTw","title":"rolesPendingInterviews_title__i6WyN","hint":"rolesPendingInterviews_hint__8g72L","list":"rolesPendingInterviews_list__+D9l-"};